import { useEffect, useState } from "react";
import { Outlet, ScrollRestoration } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { ArrowUp, MessageCircle } from "lucide-react";
import { Link } from "react-router-dom";
import { Toaster } from "sonner";

export default function PublicLayout() {
  const [showTop, setShowTop] = useState(false);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY;
      const h = document.documentElement.scrollHeight - window.innerHeight;
      setProgress(h > 0 ? (y / h) * 100 : 0);
      setShowTop(y > 400);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-[var(--bg)]">
      {/* Scroll progress */}
      <div
        className="fixed top-0 left-0 z-[60] h-[3px] bg-gradient-to-r from-[var(--brand-blue)] to-[var(--brand-orange)]"
        style={{ width: `${progress}%` }}
        data-testid="scroll-progress"
      />
      <Navbar />
      <main className="flex-1 pt-20">
        <Outlet />
      </main>
      <Footer />

      {/* Floating actions */}
      <div className="fixed bottom-6 right-6 z-40 flex flex-col gap-3">
        {showTop && (
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="h-12 w-12 rounded-full bg-white shadow-xl border border-slate-200 flex items-center justify-center text-[var(--brand-blue)] hover:bg-[var(--brand-blue)] hover:text-white transition"
            aria-label="Kembali ke atas"
            data-testid="back-to-top"
          >
            <ArrowUp className="h-5 w-5" />
          </button>
        )}
        <Link
          to="/kontak"
          className="h-14 w-14 rounded-full bg-[var(--brand-orange)] shadow-2xl text-white flex items-center justify-center hover:bg-[var(--brand-orange-dark)] transition"
          aria-label="Hubungi Kami"
          data-testid="floating-contact"
        >
          <MessageCircle className="h-6 w-6" />
        </Link>
      </div>

      <Toaster position="top-right" richColors closeButton />
      <ScrollRestoration />
    </div>
  );
}
